import React, { useState } from "react";

export default function Button3D({ children, style, ...props }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  return (
    <button
      {...props}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsPressed(false);
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      style={(() => {
        // If style prop contains backgroundColor, do not set background
        const hasBackgroundColor = style && Object.prototype.hasOwnProperty.call(style, 'backgroundColor');
        const baseStyle = {
          position: "relative",
          border: "none",
          borderRadius: "4px",
          boxShadow: isPressed
            ? "0 2px 4px rgba(0,0,0,0.3)"
            : isHovered
            ? "0 4px 8px rgba(0,0,0,0.3)"
            : "0 3px 5px rgba(0,0,0,0.2)",
          color: "#333",
          fontWeight: 500,
          padding: "6px 24px 8px 24px",
          fontSize: 16,
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          outline: "none",
          transform: isPressed
            ? "translateY(1px)"
            : isHovered
            ? "translateY(-1px)"
            : "translateY(0)",
        };
        if (!hasBackgroundColor) {
          baseStyle.background = isPressed
            ? "linear-gradient(90deg, #888a8c 0%, #a7a9ac 40%, #bfc1c2 100%)"
            : isHovered
            ? "linear-gradient(90deg, #bfc1c2 0%, #d6d8d9 40%, #a7a9ac 100%)"
            : "linear-gradient(90deg, #a7a9ac 0%, #bfc1c2 40%, #888a8c 100%)";
        }
        return { ...baseStyle, ...style };
      })()}
    >
      {children}
    </button>
  );
}
